<template>
  <qx-card title="列表">
    <span slot="titleLeft">
      【申请金额：
      <span class="primary">{{ tableData.originData.openBillAmount || 0 }}</span
      >】 【开票金额：
      <span class="primary">{{ tableData.originData.approvalAmount || 0 }}</span
      >】= 【未开票：
      <span class="primary">{{
        tableData.originData.openBillAmountNot || 0
      }}</span
      >】+ 【待确认收票：
      <span class="primary">{{
        tableData.originData.openBillAmountWait || 0
      }}</span
      >】+ 【已收票：
      <span class="primary">{{
        tableData.originData.openBillAmountHas || 0
      }}</span
      >】
    </span>
    <LogRightDialog ref="logRightDialog" busiCode="22000025" />
    <section slot="titleRight">
      <qx-permpisions permpisions="2000907">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="billManageBO.ajax?cmd=doQueryApplicationRecord"
          :params="fullSearchData"
          bizName="申请记录信息导出"
          bizCode="exp20001"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '2000919',
                    showCondition:
                      scope.row.applyState === 1 && scope.row.billType === 2,
                    name: '增加订单',
                    event: () => addOrder(scope.row),
                  },
                  {
                    permpisions: '2000920',
                    showCondition:
                      scope.row.applyState === 1 && scope.row.billType === 2,
                    name: '减少订单',
                    event: () => deleteOrder(scope.row),
                  },
                  {
                    permpisions: '2000921',
                    showCondition:
                      scope.row.applyState === 1 && scope.row.billType === 2,
                    name: '取消申请',
                    event: () => cancelApplication(scope.row),
                  },
                  {
                    permpisions: '2000908',
                    showCondition:
                      scope.row.applyState === 1 && scope.row.billType === 2,
                    name: '支付服务费',
                    event: () => payBillService(scope.row),
                  },
                  {
                    permpisions: '2000909',
                    showCondition:
                      scope.row.applyState !== 5 && scope.row.applyState !== 4,
                    name: '催票',
                    event: () => urge(scope.row),
                  },
                  {
                    permpisions: '2000906',
                    showCondition: scope.row.applyState === 4,
                    name: '确认收票',
                    event: () => invoiceConfirmation(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.flowId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  invoiceRecordList,
  invoiceRecordUrge,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        originData: {},
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'applyNum', label: '申请号码', fixed: true },
          { prop: 'createDate', label: '申请时间' },
          { prop: 'orderNum', label: '订单/账单数量' },
          { prop: 'busiAmountDouble', label: '业务金额' },
          { prop: 'billServiceAmountDouble', label: '开票服务费' },
          { prop: 'openBillAmountDouble', label: '申请金额' },
          { prop: 'approvalAmountDouble', label: '开票金额' },
          { prop: 'billRate', label: '费率' },
          { prop: 'openUserName', label: '开票方' },
          { prop: 'deductionNum', label: '抵扣票' },
          { prop: 'invoiceNumber', label: '发票号码' },
          { prop: 'expressCompany', label: '快递公司' },
          { prop: 'expressNumber', label: '快递单号' },
          { prop: 'applyStateName', label: '状态' },
          { prop: 'billTypeName', label: '开票类型' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: invoiceRecordList,
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    async addOrder (item) {
      // TODO 增加订单
      this.$message.warning('增加订单 开发中');
    },
    async deleteOrder (item) {
      // TODO 取消申请
      this.$message.warning('取消申请 开发中');
    },
    async cancelApplication (item) {
      // TODO 取消申请
      this.$message.warning('取消申请 开发中');
    },
    async payBillService (item) {
      // TODO 支付服务费
      this.$message.warning('支付服务费 开发中');
    },
    async invoiceConfirmation (item) {
      // TODO 确认收票
      this.$message.warning('确认收票 开发中');

      // if (item.billType === 3 && item.approvalAmount < item.openBillAmount) {//对于油卡消费开票，确认收票时，如果申请金额小于开票金额，则进行提示。
      //   $scope.showConfirmTabFlag = true;
      //   $scope.showConfirmObj = obj;
      // } else {
      //   $scope.resm = "确认已收到发票？";
      //   commonService.confirm($scope.resm, function () {
      //     var url = "billManageBO.ajax?cmd=confirmCollectBill";
      //     commonService.postUrl(url, { "flowId": obj.flowId }, function (data) {
      //       $scope.doQuery();
      //     }, function (data) {
      //       commonService.alert(data.message);
      //     });
      //   }, function () {
      //   }, "确定", "关闭");
      // }

    },
    async urge (item) {
      const confirmRes = await this.$confirm(`是否催促${item.openUserName}开票`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await invoiceRecordUrge({
          flowId: item.flowId,
        });
        if (!res.failed) {
          this.$message.success('催促成功');
          this.getData();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
